import {
	isSupportedBrowser,
	isLegacyBrowser,
	isSupportedPlatform,
	getBrowserInfo,
	getOsInfo
} from '../services/platformDetector';
import * as actions from '../constants/actions';

const platformDetectorMiddleware = (
	isSupportedBrowser,
	isLegacyBrowser,
	isSupportedPlatform,
	getBrowserInfo,
	getOsInfo
) => store => next => action => {
	if (action.type === actions.APP_INIT) {
		const supportedPlatform = isSupportedPlatform();
		const supportedBrowser = isSupportedBrowser() && supportedPlatform;
		const legacyBrowser = isLegacyBrowser();
		const browserInfo = getBrowserInfo();
		const osInfo = getOsInfo();
		const payload = {
			...action.payload,
			supportedBrowser,
			legacyBrowser,
			supportedPlatform,
			browserInfo,
			osInfo
		};
		return next({
			...action,
			payload
		});
	}
	return next(action);
};

export default platformDetectorMiddleware(
	isSupportedBrowser,
	isLegacyBrowser,
	isSupportedPlatform,
	getBrowserInfo,
	getOsInfo
);



// WEBPACK FOOTER //
// ./src/services/platformDetectorMiddleware.js